import React from "react";
import styles from "./AppMenu.module.css";
import { useAuth } from "../../context/AuthContext";

export default function AppMenu({ children, className = "" }) {
  const { user } = useAuth();

  return (
    <section className={[styles.appMenu, className].join(" ")}>
      <div className={styles.inner}>
        {user ? (
          <div className={styles.userBlock}>
            <div className={styles.userName}>
              {user.name} {user.surname}
            </div>
            <div className={styles.userMeta}>
              ID: {user.user_id}
            </div>
          </div>
        ) : (
          <div className={styles.userBlock}>
            <div className={styles.userName}>Loading user...</div>
          </div>
        )}

        <div className={styles.menuContent}>
          {children}
        </div>
      </div>
    </section>
  );
}